import React, { useEffect } from "react";

const useOnClickOutside = (refs: React.RefObject<HTMLElement>[], handler: (event: MouseEvent | TouchEvent) => void) => {
    useEffect(() => {
        const listener = (event: MouseEvent | TouchEvent) => {
            const clickedInside = refs.some((ref) => {
                return ref.current && ref.current.contains(event.target as Node);
            });

            if (!clickedInside) {
                handler(event);
            }
        };

        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);

        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [refs, handler]);
};

export default useOnClickOutside;
